var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "w-select",
    _vm._b(
      {
        staticClass: "f-select",
        attrs: { value: _vm.items, options: _vm.thisOptions },
        on: { input: _vm.updateItems },
        scopedSlots: _vm._u(
          [
            _vm._l(_vm.$scopedSlots, function (_, name) {
              return {
                key: name,
                fn: function (scope) {
                  return [_vm._t(name, null, null, scope)]
                },
              }
            }),
          ],
          null,
          true
        ),
      },
      "w-select",
      {
        label: _vm.label,
        single: _vm.single,
        readonly: _vm.readonly,
        disabled: _vm.disabled,
        optionDescription: _vm.optionDescription,
      },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }